import React, { useEffect, useState } from "react";
import Layout from "../../components/layout/layout";
import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "../../store/store";
import {
  fetchNotificationSettings,
  toggleNotificationSetting,
} from "../../store/profileSlice";

import NotificationEmailIcon from "../../assets/icons/notification_email.svg";
import EmailIcon from "../../assets/auth/email-icon.svg";
import EmailNorification from "../../assets/auth/emailNotification.svg";
import MobileIcon from "../../assets/auth/mobile-icon.svg";
import { useNavigate } from "react-router-dom";

import { useAppState } from "../../hooks/useAppState";
import { useAppSelector } from "../../store/hooks";

const Setting = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  // Redux selectors
  const notificationSettings = useAppSelector(
    (state: RootState) => state.profile.notificationSettings
  );
  console.log(notificationSettings, ",notificationSettings");
  const { user } = useAppState();
  const [isLoadingUser, setIsLoadingUser] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoadingUser(true);
        await dispatch(fetchNotificationSettings()).unwrap();
      } finally {
        setIsLoadingUser(false);
      }
    };
    fetchData();
  }, [dispatch]);

  // If phoneNumber is null, set SMS notification to false
  useEffect(() => {
    if (
      notificationSettings &&
      notificationSettings.SMS &&
      !notificationSettings.phoneNumber
    ) {
      dispatch(toggleNotificationSetting("SMS"));
    }
  }, [notificationSettings?.phoneNumber, notificationSettings?.SMS, dispatch]);

  const handleSendOtp = async (email: string, type: string) => {
    if (!email) {
      return;
    }

    try {
      const response = await fetch(
        "https://us-central1-supporty-staging.cloudfunctions.net/sendOTP",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ phNumber: "", email, type }),
        }
      );

      const result = await response.json();
      if (result.success) {
        // localStorage.setItem("isAuthenticated", "false");
        // logout()
        navigate("/signup/otp-verify", {
          state: { email: email, type: "Email" },
        });
      } else {
      }
    } catch (err) {
      alert("An unexpected error occurred.");
    }
  };

  const handleNotificationToggle = async (type: any) => {
    try {
      await dispatch(toggleNotificationSetting(type)).unwrap();

      if (type === "SMS" && notificationSettings && !notificationSettings.SMS) {
        navigate("/signup/mobile-otp-verify", {
          state: { phoneNumber: notificationSettings?.phoneNumber || "" }
        });
      } else if (
        type === "Email" &&
        notificationSettings &&
        !notificationSettings.email
      ) {
        handleSendOtp(user?.email || "", type);
      }
    } catch (error) {
      console.error("Failed to update email notification setting:", error);
      alert("Failed to update notification setting. Please try again.");
    }
  };
  const handleNotification = async () => {
    try {
      await dispatch(toggleNotificationSetting("notification")).unwrap();
    } catch (error) {
      console.error("Failed to update email notification setting:", error);
      alert("Failed to update notification setting. Please try again.");
    }
  };
  return (
    <Layout>
      <div className=" mx-auto"  style={{
          height: "calc(100vh - 112px)",
          overflowY: "auto",
            overflowX:'hidden'
        }}>
        <div className="space-y-3 ">
          <div className="bg-white rounded-lg   px-6 pt-7">
            <div className="text-[20px] nunito-semibold mb-4 text-[#696969] ">
              Settings
            </div>

            <div className="flex items-start mb-4 flex-col p-2 gap-3">
              <h2 className="text-[18px] nunito-semibold text-[#696969]">
                2Factor Authentication
              </h2>
              <p className="text-[16px] nunito-semibold text-[#919191]">
                Receive OTP on email or mobile.
              </p>
              <hr className="h-px  bg-gray-200 border-0 border-[#D9D9D9]  w-full" />
            </div>
            <div className="space-y-4">
              <div className="flex items-center justify-between px-3">
                <div className="flex items-center gap-4">
                  <div>
                    <img
                      src={EmailIcon}
                      alt="Video Call"
                      className="h-[48px] w-[48px]"
                    />
                  </div>
                  <div>
                    <p className="text-[18px] nunito-semibold text-[#696969] ">
                      Enable using email
                    </p>
                    <p className="text-[16px] nunito-semibold text-[#919191]">
                      Will send you 2FA code on your email
                    </p>
                  </div>
                </div>
                <label className="relative inline-flex items-center cursor-pointer">
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      disabled={isLoadingUser}
                      className="sr-only peer"
                      checked={notificationSettings?.email || false}
                      onChange={() => handleNotificationToggle("Email")}
                    />
                    <div className="w-[56px] h-[32px] bg-[#919191]   peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-indigo-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[4px] after:left-[3px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-[24px] after:w-[24px] after:transition-all peer-checked:bg-[#18ACF1]"></div>
                  </label>
                </label>
              </div>
              <div className="flex items-center justify-between mt- px-3 py-6">
                <div className="flex items-center gap-4">
                  <div>
                    <img
                      src={MobileIcon}
                      alt="Video Call"
                      className="h-[48px] w-[48px]"
                    />
                  </div>
                  <div>
                    <p className="text-[18px] nunito-semibold text-[#696969] ">
                      Enable using mobile number
                    </p>
                    <p className="text-[16px] nunito-semibold text-[#919191]">
                      Will send you 2FA code vai text SMS
                    </p>
                    <h4 className="mt-2">
                      {notificationSettings?.phoneNumber || ""}
                    </h4>
                  </div>
                </div>
                <label className="relative inline-flex items-center cursor-pointer">
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      disabled={isLoadingUser}
                      className="sr-only peer"
                      checked={notificationSettings?.SMS || false}
                      onChange={() => handleNotificationToggle("SMS")}
                    />
                    <div className="w-[56px] h-[32px] bg-[#919191]   peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-indigo-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[4px] after:left-[3px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-[24px] after:w-[24px] after:transition-all peer-checked:bg-[#18ACF1]"></div>
                  </label>
                </label>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg  px-6 ">
            <div className="flex items-start mb-4 flex-col p-2 gap-3">
              <h2 className="text-[18px] nunito-semibold text-[#696969]">
                Notification
              </h2>
              <p className="text-[16px] nunito-semibold text-[#696969]">
                Get notified for all the updates.
              </p>
              <hr className="h-px  bg-gray-200 border-0 border-[#D9D9D9]  w-full" />
            </div>
            <div className="space-y-4">
              <div className="flex items-center justify-between p-4">
                <div className="flex items-center gap-4">
                  <div>
                    <img
                      src={EmailNorification}
                      alt="Video Call"
                      className="h-[48px] w-[48px]"
                    />
                  </div>
                  <div>
                    <p className="text-[18px] nunito-semibold text-[#696969] ">
                      Email Notifications
                    </p>
                    <p className="text-[16px] nunito-semibold text-[#919191]">
                      Receive email updates about your activity
                    </p>
                  </div>
                </div>
                <label className="relative inline-flex items-center cursor-pointer">
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      disabled={isLoadingUser}
                      className="sr-only peer"
                      checked={notificationSettings?.notification || false}
                      onChange={handleNotification}
                    />
                    <div className="w-[56px] h-[32px] bg-[#919191]   peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-indigo-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[4px] after:left-[3px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-[24px] after:w-[24px] after:transition-all peer-checked:bg-[#18ACF1]"></div>
                  </label>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Setting;
